import Grid from "@mui/material/Grid2";
import MediaView from "@/app/features/shared/media-view/ui/public/MediaView.public";
import { Stack, Typography } from "@mui/material";
import { Markdown } from "@/app/features/shared/markdown/Markdown";
import { notNull } from "@/app/lib/common/not-null";
import LinkButton from "@/app/features/shared/__to_be_integrated/LinkButton";
import { RelatedInfo } from "@/app/lib/generated/graphql-types";
import { MediaRef } from "@/app/features/shared/__to_be_integrated/types/general/media/media";
import ContactView from "@/app/features/shared/related-infos/ui/ContactView";
import { RELATED_INFOS_SPACING } from "@/app/features/shared/related-infos/ui/spacing";
import Section from "@/app/features/shared/snap-section/Section";

export default function RelatedInfoViewCompact({ info }: { info: RelatedInfo }) {

    const {
        image,
        teamMember,
        showGeneralContact,
        sideImage
    } = info;

    const imageGridSize = 3;
    let contentColumns: number = 12;
    let rightSiteColumns: number = 0;

    if (image) {
        contentColumns -= imageGridSize;
    }
    if (!!teamMember || showGeneralContact || sideImage) {
        contentColumns -= 4;
        rightSiteColumns += 4;
    }

    return (
        <Section contentHeight='fit-content'>
            {/* DESKTOP */}
            <span className="hidden md:block">
                <Grid
                    container
                    className="related-info-compact-view-root hidden md:block my-16"
                    spacing={RELATED_INFOS_SPACING.layout}
                    sx={{
                        minHeight: '250px',
                    }}
                >
                    {image && (
                        <Grid size={imageGridSize}>
                            <ImageView media={image} position={info.imagePosition} />
                        </Grid>
                    )}
                    <Grid size={contentColumns}>
                        <TextView info={info} />
                    </Grid>
    
                    {rightSiteColumns > 0 && (
                        <Grid size={rightSiteColumns}>
                            {(!!teamMember || showGeneralContact) &&
                                <ContactView info={info} />
                            }
                            {sideImage && <ImageView media={sideImage} position={info.imagePosition}/>}
                        </Grid>
                    )}
                </Grid>
            </span>

            {/* MOBILE */}
            <span className="block md:hidden">
                <Stack
                    className="related-info-compact-view-root block md:hidden"
                    spacing={RELATED_INFOS_SPACING.mobile}
                >
                    <Stack direction="row" spacing={2}>
                        {image && <ImageView media={image} position={info.imagePosition}/>}
                        {sideImage && <ImageView media={sideImage} position={info.imagePosition} />}
                    </Stack>
                    <TextView info={info} />
                </Stack>
            </span>
        </Section>
    )
}

function TextView({ info }: { info: RelatedInfo}) {
    const {
        title,
        subtitle,
        description,
        links,
    } = info;

    return (
        <Stack spacing={RELATED_INFOS_SPACING.content} justifyContent="center" className="h-full">
            <Stack spacing={RELATED_INFOS_SPACING.text}>
                {subtitle && (
                    <Typography variant="subtitle2" className="hidden md:block">{subtitle}</Typography>
                )}
                {title?.trim() && <Typography variant="h2">{title}</Typography>}
                {subtitle && (
                    <Typography variant="subtitle2" className="block md:hidden">{subtitle}</Typography>
                )}
                {description && (
                    <Markdown value={description}/>
                )}
            </Stack>
            {links && links.length > 0 && (
                <Stack spacing={RELATED_INFOS_SPACING.text} sx={{ width: '100%' }}>
                    {links.filter(notNull).map((link, index) =>
                        <LinkButton key={index} link={link} />
                    )}
                </Stack>
            )}
        </Stack>
    )
}

function ImageView({ media, position }: { media: MediaRef, position?: string | null }) {
    // const isDesktop = useIsDesktop();

    return (
        <MediaView
            src={media}
            fill
            modalViewType="click"
            objectFit="cover"
            objectPosition={position || 'center'}
        />
    )
}
